module.exports = __webpack_public_path__ + "985642a7b5c39c170e0bbf4319551d0b.svg";